import { poisConstants } from '../constants';

export const poisActions = {
    getPois: () => ({ type: poisConstants.GET_MY_REQUEST}), 
    getCategories: () => ({ type: poisConstants.GET_CATEGORIES_REQUEST}), 
    getPoiDetail: (id) => ({ type: poisConstants.GET_POI_DETAIL_REQUEST, id }),    
    searchPoi: (poiQuery) => ({ type: poisConstants.SEARCH_POIS, poiQuery }),  
    setHoveredPoi: (poi) => ({ type: poisConstants.HOVERED_POI, poi }),
    clearSearchPoi: () => ({ type: poisConstants.SEARCH_POIS_CLEAR }),
};